import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiSearch, FiClock, FiUser, FiArrowRight } from 'react-icons/fi';
import { publicAPI } from '../services/api';
import { generateImageUrl, formatDate, truncateText } from '../utils/helpers';
import SectionHeader from '../components/common/SectionHeader';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './Blog.css';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 6;

  useEffect(() => {
    setLoading(true);
    publicAPI.getBlogs({ search: search || undefined, page, pageSize })
      .then(res => {
        if (res.success) {
          setBlogs(res.data.items);
          setTotalPages(res.data.totalPages);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [page, search]);

  return (
    <section className="section blog-page">
      <Helmet><title>Blog | Deepak Chauhan</title></Helmet>
      <div className="container">
        <SectionHeader title="Blog" subtitle="Articles, tutorials, and thoughts on software development" />

        <div className="blog-search">
          <FiSearch />
          <input type="text" placeholder="Search articles..." value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }} />
        </div>

        {loading ? <LoadingSpinner /> : (
          <>
            <div className="blog-grid">
              {blogs.map(blog => (
                <div key={blog.id} className="blog-card card">
                  <div className="blog-card-image">
                    <img src={generateImageUrl(blog.featuredImageUrl)} alt={blog.title} />
                    <span className="blog-category">{blog.category}</span>
                  </div>
                  <div className="blog-card-body">
                    <div className="blog-meta">
                      <span><FiClock /> {formatDate(blog.publishedDate || blog.createdAt)}</span>
                    </div>
                    <h3>{blog.title}</h3>
                    <p>{truncateText(blog.excerpt || blog.content, 120)}</p>
                    <div className="blog-tags">
                      {blog.tags?.split(',').slice(0, 3).map(t => (
                        <span key={t} className="blog-tag">{t.trim()}</span>
                      ))}
                    </div>
                    <Link to={`/blog/${blog.slug}`} className="blog-read-more">
                      Read More <FiArrowRight />
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                {[...Array(totalPages)].map((_, i) => (
                  <button key={i} className={`page-btn ${page === i + 1 ? 'active' : ''}`}
                    onClick={() => setPage(i + 1)}>{i + 1}</button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Blog;
